"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LicenseVendor = exports.AppType = exports.AppOption = exports.AppCategory = void 0;
var AppCategory;
(function (AppCategory) {
    AppCategory["claims"] = "claims";
    AppCategory["assets"] = "assets";
    AppCategory["billing"] = "billing";
    AppCategory["developer"] = "developer";
    AppCategory["general"] = "general";
    AppCategory["rejections"] = "rejections";
    AppCategory["Distributor"] = "Distributor";
})(AppCategory = exports.AppCategory || (exports.AppCategory = {}));
var AppOption;
(function (AppOption) {
    /** The number of orders to pull per claim worker at one time. */
    AppOption["OrderTakeCount"] = "OrderTakeCount";
    /** Number of times to retry a deadlock before quitting claim. */
    AppOption["Developers"] = "Developers";
    AppOption["FatalRejections"] = "FatalRejections";
    AppOption["FixableRejections"] = "FixableRejections";
    AppOption["FromAddress"] = "FromAddress";
    AppOption["GenWaterfall"] = "GenWaterfall";
    AppOption["GenerateEOW"] = "GenerateEOW";
    AppOption["RestartWorker"] = "RestartWorker";
    /** Number of days to allow redispense for remaining supply.  */
    AppOption["AssetApprovalAlerts"] = "AssetApprovalAlerts";
    AppOption["AssetApprovalEmails"] = "AssetApprovalEmails";
    AppOption["BillingEntityInformation"] = "BillingEntityInformation";
    AppOption["BillingEntityLogo"] = "BillingEntityLogo";
    AppOption["ClaimDataHotfix"] = "ClaimDataHotfix";
    AppOption["ConnectAssetCategoriesPatient"] = "ConnectAssetCategoriesPatient";
    AppOption["ConnectAssetCategoriesProv"] = "ConnectAssetCategoriesProv";
    AppOption["ConnectAssetCategoriesSite"] = "ConnectAssetCategoriesSite";
    AppOption["ConnectAssetCategoriesUser"] = "ConnectAssetCategoriesUser";
    AppOption["DaysPriorProvExpLicense"] = "DaysPriorProvExpLicense";
    AppOption["EobPayPeriods"] = "EobPayPeriods";
    AppOption["EnrollmentCC"] = "EnrollmentCC";
    AppOption["EnrollmentEmail"] = "EnrollmentEmail";
    AppOption["ERXToJSON"] = "ERXToJSON";
    AppOption["HostErrors"] = "HostErrors";
    AppOption["HostTimeout"] = "HostTimeout";
    AppOption["LoadAlertsCount"] = "LoadAlertsCount";
    AppOption["OrderCheckInAddress"] = "OrderCheckInAddress";
    AppOption["OrderCheckInDays"] = "OrderCheckInDays";
    AppOption["OrderCheckInEmails"] = "OrderCheckInEmails";
    AppOption["PatInvWaterfall"] = "PatInvWaterfall";
    AppOption["PicAllowedTitles"] = "PicAllowedTitles";
    AppOption["ProviderAlertEmailOverride"] = "ProviderAlertEmailOverride";
    AppOption["ProviderTitles"] = "ProviderTitles";
    AppOption["ReattemptWaitDays"] = "ReattemptWaitDays";
    AppOption["RejectionRetryWaitDays"] = "RejectionRetryWaitDays";
    AppOption["ResetRejections"] = "ResetRejections";
    AppOption["RunStatusCronOnce"] = "RunStatusCronOnce";
    AppOption["SupplyDays"] = "SupplyDays";
    AppOption["Test"] = "Test";
    AppOption["ToggleRefills"] = "ToggleRefills";
    AppOption["UnknownRejections"] = "UnknownRejections";
    AppOption["UpdateLedgerData"] = "UpdateLedgerData";
    AppOption["UpdateMissingClaimsInLedger"] = "UpdateMissingClaimsInLedger";
    AppOption["UseNewDispenseMethod"] = "UseNewDispenseMethod";
    /** Distributor */
    AppOption["ShippingMethod"] = "ShippingMethod";
    /** Global */
    AppOption["AppHostUrl"] = "AppHostUrl";
})(AppOption = exports.AppOption || (exports.AppOption = {}));
var AppType;
(function (AppType) {
    AppType["array"] = "array";
    AppType["boolean"] = "boolean";
    AppType["number"] = "number";
    AppType["string"] = "string";
    /** Triggers are actions and don't modify their own values. */
    AppType["trigger"] = "trigger";
})(AppType = exports.AppType || (exports.AppType = {}));
var LicenseVendor;
(function (LicenseVendor) {
    LicenseVendor["agGrid"] = "ag-Grid";
})(LicenseVendor = exports.LicenseVendor || (exports.LicenseVendor = {}));



//////////////////
// WEBPACK FOOTER
// ./src/shared/app-settings.ts
// module id = 115
// module chunks = 0 1 2